// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AdminLoginController = function ($scope, $rootScope, $routeParams, $http, $location, AdminLogin, AccountLogout) {
    if ($rootScope.accessToken) {
        AccountLogout.logout();
    }

    $scope.dto = AdminLogin.get({ entityId: $routeParams.entityId });

    $scope.login = function () {
        $scope.dto.EntityId = $routeParams.entityId;
        $scope.dto.Secret = $routeParams.secret;
        $scope.dto.$save({}, function (data) {
            $scope.dto.Password = null;
            if (data["Token"]) {
                $rootScope.accessToken = data["Token"];
                $rootScope.permissions = data["Permissions"];
                $rootScope.refreshToken = null;
                $rootScope.username = "Admin " + data.EntityName;
                $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.accessToken;
                localStorage.setItem('username', $rootScope.username);
                localStorage.setItem('access_token', $rootScope.accessToken);
                localStorage.setItem('refresh_token', $rootScope.refreshToken);
                localStorage.setItem('permissions', angular.toJson($rootScope.permissions));
                localStorage.setItem("first_name", null);
                localStorage.setItem("last_name", null);
                localStorage.setItem("email", data.Email);

                $location.path($rootScope.defaultLocation());
            }
        });
    };

    if ($routeParams.secret) {
        $scope.dto.$promise.then(function () {
            $scope.login();
        });
    }
};
AdminLoginController.$inject = ["$scope", '$rootScope', '$routeParams', '$http', '$location', 'AdminLogin', 'AccountLogout'];
